import {useCallback, useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import ActionBar from "~/layout/ActionBar";
import {
    Icon,
    Loading,
    Button
} from "~/components";
import {
    OrderTable,
    OrderSearchBar
} from "../components";
import {
    orderActions,
    orderErrorSelector,
    orderFilterSelector,
    orderItemsSelector,
    orderLoadingSelector,
    orderPaginationSelector
} from "../../../reduxs/Order/orderSlice";
import {
    apiError,
    handleRequest
} from "../../../utils";
import {orderApi} from "../../../api";
import BillPrint from "../../../components/BillPrint";
import '../style/PrintBill.scss';
const Order = () =>
{
    const dispatch = useDispatch();
    const items = useSelector(orderItemsSelector);
    const loading = useSelector(orderLoadingSelector);
    const error = useSelector(orderErrorSelector);
    const filter = useSelector(orderFilterSelector);
    const pagination = useSelector(orderPaginationSelector);
    const [detailsData, setDetailsData] = useState({});
    const [detailsLoading, setDetailsLoading] = useState({});
    const [printingOrderId, setPrintingOrderId] = useState(null);
    const billPrintRef = useRef();

    //Events
    const eventHandlers = {
        //Load data
        load: useCallback(() => {
            dispatch(orderActions.fetchData());
        }, [dispatch]),

        //Filter
        filter: useCallback((newFilter) => {
            dispatch(orderActions.setFilter(newFilter));
            dispatch(orderActions.setPagination({page: 1}));
        }, [dispatch]),

        //Pagination
        pagination: useCallback((page) => {
            dispatch(orderActions.setPagination({page}));
        }, [dispatch]),

        //print bill
        handlePrintBill: async (record, e) =>
        {
            e.stopPropagation(); // Prevent row expand

            // Load order details if not already loaded
            if (!detailsData[record.id])
            {
                setDetailsLoading(prev => ({...prev, [record.id]: true}));

                let [error, response] = await handleRequest(orderApi.get(record.id));

                setDetailsLoading(prev => ({...prev, [record.id]: false}));

                if (!apiError('Lấy chi tiết đơn hàng thất bại', error, response))
                {
                    setDetailsData(prev => ({
                        ...prev,
                        [record.id]: response?.data || {}
                    }));
                }
                else
                {
                    return; // Stop if failed to load
                }
            }

            // Set printing order and trigger print after DOM update
            setPrintingOrderId(record.id);

            setTimeout(() => {
                window.print();
                //setPrintingOrderId(null);
            }, 500);
        }
    }

    //Load data
    useEffect(() =>
    {
        let isMounted = true;
        if (isMounted) eventHandlers.load();
        return () => { isMounted = false };
    }, [filter, pagination.page]);


    // Prepare bill data for printing
    const prepareBillData = (orderId) =>
    {
        const orderDetails = detailsData[orderId];

        if (!orderDetails) return null;

        return {
            code: orderDetails.code || '',
            date: orderDetails.created || '',
            cashier: orderDetails.user_created_name || '',
            customer: orderDetails.customer_name || '',
            address: orderDetails.customer_address || '',
            phone: orderDetails.customer_phone || '',
            items: orderDetails.items || [],
            subtotal: orderDetails.subtotal || 0,
            totalVat: orderDetails.vat || 0,
            discountAmount: orderDetails.discount || 0,
            discountType: orderDetails.discount_type || 'amount',
            discount: orderDetails.discount_value || 0,
            shipping: orderDetails.shipping || 0,
            total: orderDetails.total || 0,
            paid: orderDetails.paid || 0,
            change: orderDetails.change || 0
        };
    };

    const currentBillData = printingOrderId ? prepareBillData(printingOrderId) : null;

    return (
        <>
            <ActionBar title="Đơn hàng">
                <Button outline onClick={eventHandlers.load}>{Icon.reload}</Button>
            </ActionBar>
            <div className="container">
                <div className="content p-2">
                    {loading && <Loading/>}
                    <OrderSearchBar
                        filter={filter}
                        onFilterChange={eventHandlers.filter}
                    />
                    <OrderTable
                        items={items}
                        pagination={pagination}
                        onPaginationChange={eventHandlers.pagination}
                        setPrintingOrderId={setPrintingOrderId}
                        detailsData={detailsData}
                        setDetailsData={setDetailsData}
                        detailsLoading={detailsLoading}
                        setDetailsLoading={setDetailsLoading}
                        handlePrintBill={eventHandlers.handlePrintBill}
                    />
                </div>
            </div>
            {currentBillData && (
                <div id="bill-print-wrapper" style={{display: 'none'}}>
                    <BillPrint
                        ref={billPrintRef}
                        billData={currentBillData}
                    />
                </div>
            )}
        </>
    );
}

export default Order;
